import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getSearchListContacts = async () => {
  const options = prepareRequestOptions(
    `/admin/contacts/search-list`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

const getListContacts = async (query) => {
  const options = prepareRequestOptions(
    `/admin/contacts/${query}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export default getListContacts;
